import 'es6-promise/auto';
import Vue from 'vue';
import Vuex from 'vuex';
import mutations from '../store/mutations';
import firebase from 'firebase/app'
import 'firebase/auth'
import db from '../firebase'

Vue.use(Vuex);

//=======vuex store start===========
const store = new Vuex.Store({
    state: {
      favorites:[],
      needToConfirmTAS:false,
      TAS:'',
      loadingStatus:{bids:false,purchases:false},
      overlayHitTarget:0,
      autoRevise:false,
      audio:{},
      audio2:{},
      audio3:{},
      showCart:false,
      intervalCounter:'',
      myDashboardTabId:0,
      ua:[],
      autoGoToCart:false,
      usercart:[],
      openoffers:[],
      purchases:[],
      openoffersConfirmed:[],
      purchasesConfirmed:[],
      autionresults:[],
      fetchingFeed:false,
      feed:[],
      watchGallerySortOptions:['Sort By...','Price High To Low','Price Low To High','Brand'],
      gallerySortOptions:['Sort By...','Price High To Low','Price Low To High','Carat High To Low','Carat Low To High','Color High To Low','Color Low To High','Clarity High To Low','Clarity Low To High'],
        galleryState:{
          filterCount:0,
          sortBy:'Sort By...',
          sizesFilter:[0,20],
          showMoreFilters:false,
          reloadData:false,
          reloadFilters:false,
          showClearFilters:false,
          search:'',
          isActive:false,
          filters:{},
          emmitedFilter:{},
          filtersVisible:{},
          list:[],
          bigList:[],
        },
        reloadBid: false,
        left_open: false,
        right_open: false,
        activeReqs:0,
        bounce: false,
        auth: { 
            role:'',
            idToken: null,
            user: null,
            myInfo:null,
            verifyUser : {finished:false, error:'', status:''},
            signin : {finished:false,error:'', status:''},
            signup : {finished:false,error:'', status:''},
            passwordReset : {finished:false,error:'', status:''},
            forgotPassword : {finished:false,error:'', status:''}
          },
        loading: false,
        error: null,
        userDummy: {
            name: "Dave",
            picture: require('../assets/img/authors/avatar1.jpg'),
            job: "Project Manager"
        }
    },
    mutations,
    actions:{
      fetchFeed ({commit,dispatch}, payload) {     
        var getItems = firebase.functions().httpsCallable("circaEP");
        var that=this
        if(that.state.feed.length==0 && !that.state.fetchingFeed)
        {
          commit('addWebReq')
          that.state.fetchingFeed=true;
            getItems({action:'getItems'})
                .then(function(result) {
                  commit('decWebReq')                  
                    that.state.feed = JSON.parse(JSON.stringify(result.data))                                            
                    that.state.fetchingFeed=false; 
                    that.state.galleryState.reloadData=true                              
                })
                .catch(function(error) {
                  commit('decWebReq')
                    that.state.fetchingFeed=false;                               
                });
        }else
        {
        }
      },
      fetchFeedSilent ({commit,dispatch}, payload) {        
        var getItems = firebase.functions().httpsCallable("circaEP");
        var that=this
        that.state.fetchingFeed=true;
        getItems({action:'getItems'})
            .then(function(result) {
              
                that.state.feed = JSON.parse(JSON.stringify(result.data))     
                that.state.fetchingFeed=false; 
                that.state.galleryState.reloadData=true                              
            })
            .catch(function(error) {
                that.state.fetchingFeed=false;                               
            });
        
      },
      getMyBids ({commit,dispatch}, payload) {        
        var myBids = firebase.functions().httpsCallable("circaEP");
        var data={action:'myBids'}
        var that=this        
        that.state.loadingStatus.bids = true;
        myBids(data)
            .then(function(result) {                              
                that.state.openoffers=result.data
                if(that.state.openoffers.length>0){
                  const tempArrSorted = that.state.openoffers.sort((a, b) => {
                  return b.date._seconds-a.date._seconds
                  })
                  that.state.openoffers = tempArrSorted
                }
                that.state.loadingStatus.bids = false;
            })
            .catch(function(error) {    
              that.state.loadingStatus.bids = false;          
            }); 
      },
      getMyPurchases ({commit,dispatch}, payload) {
        var myPurchases = firebase.functions().httpsCallable("circaEP");
        var data={action:'myPurchases'}
        var that=this        
        that.state.loadingStatus.purchases = true;
        myPurchases(data)
            .then(function(result) {              
                that.state.purchases= result.data
                const tempArrSorted = that.state.purchases.sort((a, b) => {
                return b.date._seconds-a.date._seconds
                })
                that.state.purchases = tempArrSorted
                that.state.loadingStatus.purchases = false;
            })
            .catch(function(error) {    
              that.state.loadingStatus.purchases = false;          
            }); 
        },
      
        autoSignIn ({commit}, payload) {
            commit('setUser', {
                payload
            })
        },
        getFavorites({commit, dispatch}, payload) {            
          try{
            var user = this.state.auth.userCC.user_id
            db.collection("wishlist").doc(user).get().then(doc2 =>{
              this.state.favorites = doc2.data().favorites
            })
            .catch(e=>{
              console.log(e);
            })
          }
          catch(e){}
        },
        saveFavorites({commit, dispatch}, payload) {            
          var user = this.state.auth.userCC.user_id
          db.collection("wishlist").doc(user).get().then(doc =>{
            var docData = doc.data()
            docData.favorites = this.state.favorites
            db.collection("wishlist").doc(user).set(docData);
          })
          .catch(e=>{
            db.collection("wishlist").doc(user).set({"favorites":this.state.favorites});
          })

          
        },
        signUserIn ({commit, dispatch}, payload) {            
            commit('addWebReq')
            commit('authStatusChanged','')
            commit('authStateChanged', false)
            commit('setLoading', true)
            commit('clearError')
            firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
            .then(function() {
              firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
              .then(
                user => {
                  commit('decWebReq')
                  commit('authStatusChanged','')
                  commit('setLoading', false)
                  // const newUser = {
                  //   id: user.uid,
                  //   name: user.displayName,
                  //   email: user.email,
                  //   photoUrl: user.photoURL
                  // }
                  const secondsSinceEpoch = Math.round(Date.now())  
                  try{
                      localStorage.setItem('lastLoginAt',secondsSinceEpoch)
                  }  
                  catch(e){
                      //console.log(e);
                  }
                  var tmpObj = JSON.parse(JSON.stringify(user))                  
                  db.collection("users").doc(tmpObj.user.uid).set({                      
                      lastLoginAt:secondsSinceEpoch
                  });
                  commit('setUser', user)
                  commit('authStateChanged', true)
                }
              )
              .catch(
                error => {
                  commit('setLoading', false)
                  commit('setError', error.message)
                  commit('authStateChanged', true)
                  commit('decWebReq')
                  commit('authStatusChanged',error.message)
                  //console.log(error)
                }
              )
            })
            .catch(function(error) {
                console.log(error)
              // Handle Errors here.
              var errorCode = error.code;
              var errorMessage = error.message;
            });       
            
          },
          signUserInGoogle ({commit}) {
            commit('setLoading', true)
            commit('clearError')
            firebase.auth().signInWithPopup(new firebase.auth.GoogleAuthProvider())
              .then(
                user => {
                  commit('setLoading', false)
                  // const newUser = {
                  //   id: user.uid,
                  //   name: user.displayName,
                  //   email: user.email,
                  //   photoUrl: user.photoURL
                  // }
                  commit('setUser', user)
                  // const now = new Date()
                  // const expirationDate = new Date(now.getTime() + res.data.expires_in * 1000)
                  // localStorage.setItem('token', user)
                  // localStorage.setItem('expirationDate', expirationDate)
                  // commit('authUser', {
                  //   token: res.data.access_token
                  // })
                  // commit('authStateChanged', true)
                  // dispatch('setLogoutTimer', res.data.expires_in)     
                }
              )
              .catch(
                error => {
                  commit('setLoading', false)
                  commit('setError', error)
                  //console.log(error)
                }
              )
          },
          autoSignIn ({commit}, payload) {
            commit('setUser', {
              payload
            })
          },
          resetPasswordWithEmail ({ commit }, payload) {
            const { email } = payload
            commit('setLoading', true)
            firebase.auth().sendPasswordResetEmail(email)
            .then(
              () => {
                commit('setLoading', false)
                console.log('Email Sent')
              }
            )
            .catch(
              error => {
                commit('setLoading', false)
                commit('setError', error)
                console.log(error)
              }
            )
          },
          logout ({commit}) {
            var tmpObj = JSON.parse(JSON.stringify(this.state.user))
            // db.collection("users").doc(tmpObj.user.uid).set({                      
            //     is_online:false
            // });            
            setTimeout(() => {
              firebase.auth().signOut()
            }, 500);
            setTimeout(() => {
              window.location='/'
            }, 1000);
            
            //commit('setUser', null)            
          },
            clearAllIntervals({commit, dispatch}){
              try
              {
                this.state.intervals.forEach(i=>{              
                  window.clearInterval(i)
                    })            
                this.state.intervals=[]
              }
              catch(e){}
            },
            addWebReq({commit, dispatch}){
              this.state.activeReqs++
              if(this.state.activeReqs>0)
                this.state.preloader=true
              else
                this.state.preloader=false
            },
            decWebReq({commit, dispatch}){
              this.state.activeReqs--
              if(this.state.activeReqs>0)
                this.state.preloader=true
              else
                this.state.preloader=false
            },
            setToken({commit, dispatch}, token) {      
                commit('setToken',token)
              },
    },
    getters:{
        isInFavorites: (state)=> (sku,cycle) => {
          if(!state.favorites)
            return false
          else
            var favoritesindex = state.favorites.findIndex(x=>x.sku==sku && x.cycle==cycle)
            if(favoritesindex>=0)
                return true
            else
                return false
        },
        loading (state) {
            return state.loading
          },
          error (state) {
            return state.error
          },
          user (state) {
            return state.user
          },
          // user (state) {
          //   return state.auth.user
          // },
          authToken (state) {
            return state.auth.idToken
          },
          isAuthenticated (state) {
            return state.auth.idToken !== null
          },
          authError(state)
          {
            return state.auth.signin.error
          },
          authFinished(state)
          {
            return state.auth.signin.finished
          },
          signupFinished(state)
          {
            return state.auth.signup.finished
          },
          signupError(state)
          {
            return JSON.stringify(state.auth.signup.error).replace('"','').replace('"','')
          },
          authStatus(state)
          {
            return JSON.stringify(state.auth.signin.error).replace('"','').replace('"','')
          },
          forgotPasswordEmailSent(state)
          {
            return state.auth.forgotPassword.finished
          },
          passwordWasReset(state)
          {
            return state.auth.passwordReset.finished && state.auth.passwordReset.error==''
          },
          forgotPasswordError(state)
          {
            return state.auth.forgotPassword.error
          },
          passwordResetFailed(state)
          {
            return state.auth.passwordReset.finished
          },
          resetPasswordError(state)
          {
            return state.auth.passwordReset.error
          },
          verifyUserError(state)
          {
            return state.auth.verifyUser.error
          },
          verifyUser(state)
          {
            return state.auth.verifyUser.finished
          },
    }
});
//=======vuex store end===========
export default store


// WEBPACK FOOTER //
// ./src/store/store.js